import { render, staticRenderFns } from "./ProductTemplateList2.vue?vue&type=template&id=55d10b86&scoped=true&"
import script from "./ProductTemplateList2.vue?vue&type=script&lang=js&"
export * from "./ProductTemplateList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d10b86",
  null
  
)

export default component.exports